import Company from "pages/Company/Company"
import CompanyForm from "pages/Company/CompanyForm"
import Home from "pages/Home"
import Booking from "pages/KostPages/Booking/Booking"
import BookingForm from "pages/KostPages/Booking/BookingForm"
import Cashflow from "pages/KostPages/Cashflow/Cashflow"
import Dashboard from "pages/CompanyPages/Dashboard"
import Expenses from "pages/KostPages/Expenses/Expenses"
import KostSetting from "pages/KostPages/KostSetting/KostSetting"
import RoomSetting from "pages/KostPages/KostSetting/RoomSetting"
import RoomTypeSetting from "pages/KostPages/KostSetting/RoomType"
import Room from "pages/KostPages/Room/Room"
import Tenant from "pages/KostPages/Tenant/Tenant"
import TenantForm from "pages/KostPages/Tenant/TenantForm"
import Location from "pages/Location/Location"
import LocationForm from "pages/Location/LocationForm"
import Customer from "pages/LocationPages/Customer/Customer"
import CustomerForm from "pages/LocationPages/Customer/CustomerForm"
import CustomerCard from "pages/LocationPages/CustomerCard/CustomerCard"
import CustomerCardForm from "pages/LocationPages/CustomerCard/CustomerCardForm"
import Transaction from "pages/LocationPages/Transaction/Transaction"
import Login from "pages/Login"
import BankForm from "pages/Setting/Bank/BankForm"
import CreditCard from "pages/Setting/CreditCard/CreditCard"
import CreditCardForm from "pages/Setting/CreditCard/CreditCardForm"
import EDC from "pages/Setting/EDC/EDC"
import EDCForm from "pages/Setting/EDC/EDCForm"
import Setting from "pages/Setting/Setting"
import Vendor from "pages/Setting/Vendor/Vendor"
import SystemSetting from "pages/SystemSetting/SystemSetting"
import SystemSettingForm from "pages/SystemSetting/SystemSettingForm"
import User from "pages/User/User"
import UserForm from "pages/User/UserForm"
import UserAccess from "pages/UserAccess/UserAccess"
import Project from "pages/CompanyPages/Project/Project"
import ProjectForm from "pages/CompanyPages/Project/ProjectForm"
import Income from "pages/CompanyPages/IncomeProject/IncomeProject"
import Payment from "pages/CompanyPages/Payment/Payment"
import PaymentForm from "pages/CompanyPages/Payment/PaymentForm"
import PaymentView from "pages/CompanyPages/Payment/PaymentView"

import PaymentSubContractor from "pages/CompanyPages/PaymentSubContractor/Payment"
import PaymentSubContractorForm from "pages/CompanyPages/PaymentSubContractor/PaymentForm"
import PaymentSubContractorView from "pages/CompanyPages/PaymentSubContractor/PaymentView"


import ProjectView from "pages/CompanyPages/Project/ProjectView"
import AccessDenied from "pages/AccessDenied"
import PageNotFound from "pages/PageNotFound"
import SubContractor from "pages/CompanyPages/SubContractor/SubContractor"
import ProductionBank from "pages/CompanyPages/ProductionBank/ProductionBank"
import Bank from "pages/Bank/Bank"
import ContractorForm from "pages/Contractor/ContractorForm"
import Contractor from "pages/Contractor/Contractor"

export const routes = [
   {
      path: "/login",
      element: <Login />
   },
   {
      path: "/",
      element: <Home />
   },
   {
      path: "/company-setting",
      element: <Company />
   },
   {
      path: "/company-setting/form",
      element: <CompanyForm />
   },
   {
      path: "/contractor-setting",
      element: <Contractor />
   },
   {
      path: "/contractor-setting/form",
      element: <ContractorForm />
   },
   {
      path: "/user-setting",
      element: <User />
   },
   {
      path: "/user-setting/form",
      element: <UserForm />
   },
   {
      path: "/user-setting/user-access",
      element: <UserAccess />
   },
   {
      path: "/company/dashboard",
      element: <Dashboard />
   },
   {
      path: "/company/project",
      element: <Project />
   },
   {
      path: "/company/project/form",
      element: <ProjectForm />
   },
   {
      path: "/company/project/view",
      element: <ProjectView />
   },
   {
      path: "/company/income",
      element: <Income />
   },
   {
      path: "/company/payment-client",
      element: <Payment />
   },
   {
      path: "/company/payment-client/form",
      element: <PaymentForm />
   },
   {
      path: "/company/payment-client/view",
      element: <PaymentView />
   },
   {
      path: "/company/payment-subcontractor",
      element: <PaymentSubContractor />
   },
   {
      path: "/company/payment-subcontractor/form",
      element: <PaymentSubContractorForm />
   },
   {
      path: "/company/payment-subcontractor/view",
      element: <PaymentSubContractorView/>
   },
   {
      path: "/company/subcon",
      element: <SubContractor />
   },
   {
      path: "/company/production-bank",
      element: <ProductionBank />
   },
   {
      path: "/access-denied",
      element: <AccessDenied />
   },
   {
      path: "/page-not-found",
      element: <PageNotFound />
   },
   {
      path: "/bank",
      element: <Bank />
   },









   {
      path: "/location-setting",
      element: <Location />
   },
   {
      path: "/location/form",
      element: <LocationForm />
   },

   {
      path: "/bank",
      element: <Bank />
   },
   {
      path: "/bank/form",
      element: <BankForm />
   },
   {
      path: "/credit-card",
      element: <CreditCard />
   },
   {
      path: "/credit-card/form",
      element: <CreditCardForm />
   },
   {
      path: "/vendor",
      element: <Vendor />
   },
   {
      path: "/location/customer",
      element: <Customer />
   },
   {
      path: "/location/customer/form",
      element: <CustomerForm />
   },
   {
      path: "/location/customer-card",
      element: <CustomerCard />
   },
   {
      path: "/location/customer-card/form",
      element: <CustomerCardForm />
   },

   {
      path: "/setting",
      element: <Setting />
   },
   {
      path: "/edc",
      element: <EDC />
   },
   {
      path: "/edc/form",
      element: <EDCForm />
   },

   {
      path: "/location/transaction",
      element: <Transaction />
   },

   {
      path: "/setting/system-setting",
      element: <SystemSetting />
   },
   {
      path: "/setting/system-setting/form",
      element: <SystemSettingForm />
   },

 


   {
      path: "/kost/dashboard",
      element: <Dashboard />
   },

   {
      path: "/kost/setting",
      element: <KostSetting />
   },
   {
      path: "/kost/setting/room-type",
      element: <RoomTypeSetting />
   },
   {
      path: "/kost/setting/room-setting",
      element: <RoomSetting />
   },

   {
      path: "/kost/tenant",
      element: <Tenant />
   },
   {
      path: "/kost/tenant/form",
      element: <TenantForm />
   },

   {
      path: "/kost/room",
      element: <Room />
   },

   {
      path: "/kost/booking",
      element: <Booking />
   },
   {
      path: "/kost/booking/form",
      element: <BookingForm />
   },

   {
      path: "/kost/payment",
      element: <Payment />
   },
   {
      path: "/kost/payment/form",
      element: <PaymentForm />
   },

   {
      path: "/kost/expense",
      element: <Expenses />
   },

   {
      path: "/kost/cashflow",
      element: <Cashflow />
   },


]

export const ROLE_ADMIN = "admin"
export const ROLE_OWNER = "owner"